import constants from "./constants";

export default {
  required(value: string) {
    if (!value || !value.length) {
      return constants.VALIDATION.REQUIRED;
    }
    return true;
  },
  email(value: string) {
  // Field is empty, should pass
  if (!value || !value.length) {
    return true;
  }
  // Check if email
  if (!/[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}/.test(value)) {
    return constants.VALIDATION.INVALID_EMAIL;
  }
  return true;
  },
  minLength(value: string, [limit]) {
    if (!value || !value.length) {
      return true;
    }
    if (value.length < limit) {
      return constants.VALIDATION.MIN_LENGTH(limit)
    }
    return true;
  },
  maxLength(value: string, [limit]) {
    if (!value || !value.length) {
      return true;
    }
    if (value.length > limit) {
      return constants.VALIDATION.MAX_LENGTH(limit)
    }
    return true;
  },
  passwordConfirm(value: string, [password], ctx) {
    const compare_to = ctx.form[password];
    if (compare_to && value) {
      if (value !== compare_to) {
        return constants.VALIDATION.PASSWORD_CONFIRM;
      }
    }
    return true;
  }
}
